var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('box-service',{attrs:{"list":_vm.serviceList},on:{"handleClick":_vm.handleClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }